<template>
  <div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <form>
          <h1 class="mt-4 section-divider">
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.father')
            }}
          </h1>
          <div class="row">
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.nameKh'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_name_kh
                        ? profile.parent.father_name_kh
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.nameEn'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_name_en
                        ? profile.parent.father_name_en
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_dob
                        ? profile.parent.father_dob
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.occupation'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_occupation
                        ? profile.parent.father_occupation.occupation_name_en
                          ? profile.parent.father_occupation.occupation_name_en
                          : '-'
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.nationality'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_nationality
                        ? profile.parent.father_nationality.nationality
                          ? profile.parent.father_nationality.nationality
                          : '-'
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.email'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_emails
                        ? profile.parent.father_emails
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.facebook'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_facebook
                        ? profile.parent.father_facebook
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.line'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_line
                        ? profile.parent.father_line
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.linkIn'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.father_linked_in
                        ? profile.parent.father_linked_in
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.phone'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label"
                    >{{
                      profile.parent
                        ? profile.parent.father_phone1
                          ? profile.parent.father_phone1
                          : '-'
                        : '-'
                    }}
                    /
                    {{
                      profile.parent
                        ? profile.parent.father_phone2
                          ? profile.parent.father_phone2
                          : ''
                        : ''
                    }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <div class="col-md-12 text-center">
                  <div id="img-frame" class="text-center">
                    <img
                      v-lazy="{
                        src: photoFather(profile),
                        error: onErrorFather(profile),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Mother -->
          <h1 class="mt-4 section-divider">
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.mother')
            }}
          </h1>
          <div class="row">
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.nameKh'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_name_kh
                        ? profile.parent.mother_name_kh
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.nameEn'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_name_en
                        ? profile.parent.mother_name_en
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_dob
                        ? profile.parent.mother_dob
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.occupation'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_occupation
                        ? profile.parent.mother_occupation.occupation_name_en
                          ? profile.parent.mother_occupation.occupation_name_en
                          : '-'
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.nationality'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_nationality
                        ? profile.parent.mother_nationality.nationality
                          ? profile.parent.mother_nationality.nationality
                          : '-'
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.email'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_emails
                        ? profile.parent.mother_emails
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.facebook'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_facebook
                        ? profile.parent.mother_facebook
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.line'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_line
                        ? profile.parent.mother_line
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.linkIn'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label">{{
                    profile.parent
                      ? profile.parent.mother_linked_in
                        ? profile.parent.mother_linked_in
                        : '-'
                      : '-'
                  }}</label>
                </div>
              </div>
              <div class="row form-group">
                <span class="col-md-5 form-col-label control-label text-right">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.phone'
                    )
                  }}
                </span>
                <div class="col-md-7 ts-whitespace-no-wrap">
                  <label class="col-md-5 form-col-label control-label"
                    >{{
                      profile.parent
                        ? profile.parent.mother_phone1
                          ? profile.parent.mother_phone1
                          : '-'
                        : '-'
                    }}
                    /
                    {{
                      profile.parent
                        ? profile.parent.mother_phone2
                          ? profile.parent.mother_phone2
                          : ''
                        : ''
                    }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row form-group">
                <div class="col-md-12 text-center">
                  <div id="img-frame" class="text-center">
                    <img
                      v-lazy="{
                        src: photoMother(profile),
                        error: onErrorMother(profile),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'parent-show',
  data() {
    return {
      errors: new Errors(),
      manPhoto: require('../../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../../assets/staff-default-women.png'),
      file: require('../../../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('home/student', ['profile'])
  },
  methods: {
    photoFather(record) {
      if (record.parent) {
        return record.parent.father_photo
      }
      return this.manPhoto
    },
    onErrorFather() {
      event ? (event.target.src = this.manPhoto) : ''
    },
    photoMother(record) {
      if (record.parent) {
        return record.parent.mother_photo
      }
      return this.womenPhoto
    },
    onErrorMother() {
      event ? (event.target.src = this.womenPhoto) : ''
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 35%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
